import { render, staticRenderFns } from "./TrainingStepImageAnnotation.vue?vue&type=template&id=11cbb0f6&scoped=true&"
import script from "./TrainingStepImageAnnotation.vue?vue&type=script&lang=js&"
export * from "./TrainingStepImageAnnotation.vue?vue&type=script&lang=js&"
import style0 from "./TrainingStepImageAnnotation.vue?vue&type=style&index=0&id=11cbb0f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cbb0f6",
  null
  
)

export default component.exports